// @flow
import { get, post } from './common';
import { handleAPIErrors } from '../sentry-util';

export const getVirtualShelf = async (imei: string, mobile: string, session: string) => {
	try {
		const res = await get(
			'/virtualshelf/getShelfData',
			{
				imei,
				user_id: mobile,
			},
			{ session }
		);

		const { status = false } = res;
		if (!status) {
			throw new Error('No products available');
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/virtualshelf/getShelfData', 'GET', {
			imei,
			mobile,
		});
		throw error;
	}
};

export const notifyUser = async (reqPayload: Object, session: string) => {
	try {
		const res = await post('/virtualshelf/setNotifyData', reqPayload, { session });
		const { status = false } = res;
		if (!status) {
			throw new Error('Error while submitting data.');
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/virtualshelf/setNotifyData', 'POST', reqPayload);
		throw error;
	}
};

export const getAffiliateData = async (imei: string, affiliateID: string, mobile: string, session: string) => {
	try {
		const res = await get(
			'/afl/getProducts',
			{
				imei,
				affiliateID,
				user_id: mobile,
			},
			{ session }
		);

		const { status = false } = res;
		if (!status) {
			throw new Error('No products available');
		}
		return res;
	} catch (error) {
		handleAPIErrors(error, '/afl/getProducts', 'GET', {
			imei,
			mobile,
		});
		throw error;
	}
};
